import React from 'react';
import {Button, SvgIcon} from "@mui/material";
import ChartImplementationCreateUpdateForm from "./DataGridImplementationCreateUpdateForm";
import localStrings from "../../../localStrings";
import {MODE_CREATE} from "../../../components/CrudFrom/GeneralEditor";
import {Link as RouterLink} from "react-router-dom";
import {dataGridImplementationListRoute, dashboardBaseRoute, establishmentListRoute} from "../../../routes/dashboard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PageWithTitle from "../../../components/pages/pageWithTitle";

const DataGridImplementationAddView = () => {


  function getMainButtons() {
    return (


      <RouterLink to={'/' + dashboardBaseRoute + '/' + dataGridImplementationListRoute}
                  style={{ textDecoration: 'none' }}
      >
        <Button
          color="primary"
          variant="contained"
          startIcon={(
            <SvgIcon>
              <ArrowBackIcon />
            </SvgIcon>
          )}
        >
          {localStrings.backToList}
        </Button>
      </RouterLink>
    )
  }

  return (
    <PageWithTitle title={localStrings.createDataGridImplementation} mainButtons={getMainButtons()}>
      <ChartImplementationCreateUpdateForm modeEdit={MODE_CREATE}/>
    </PageWithTitle>
  );
};

export default DataGridImplementationAddView;
